package at.theatervogelweide.admin.contract.news

import at.theatervogelweide.admin.contract.AdminResult
import at.theatervogelweide.admin.contract.VersionedId
import kotlinx.rpc.annotations.Rpc

/**
 * Neuigkeiten (#21). The list is in the order the public site shows it.
 *
 * Images are uploaded over plain HTTP to `POST /api/images/news-items` first; the [NewsDraft] then names them by
 * their ids, and saving it attaches new images and removes the ones it no longer lists, files included.
 */
@Rpc
interface NewsService {
    suspend fun list(): AdminResult<List<NewsListEntry>>

    suspend fun load(id: Long): AdminResult<NewsEditor>

    /** The signed-in person becomes the author; the new item goes to the top of the list. */
    suspend fun create(draft: NewsDraft): AdminResult<NewsEditor>

    /** [NewsDraft.publishUnderMyName] makes the signed-in person the author. */
    suspend fun save(item: VersionedId, draft: NewsDraft): AdminResult<NewsEditor>

    /** [order] must list every item, each with the version the web app last saw; answers with the new list. */
    suspend fun reorder(order: List<VersionedId>): AdminResult<List<NewsListEntry>>

    /** Deletes the item and its images, files included. */
    suspend fun delete(item: VersionedId): AdminResult<Unit>
}
